/**
 * Wraps an asynchronous function to ensure it takes at least a specified 
 * amount of time to complete. 
 * * This prevents "flickering" in UIs where a loading 
 * state is short and disappears too quickly for users to register.
 *
 * @template T
 * @param {() => Promise<T>} asyncFunc - The asynchronous function to execute.
 * @param {number} [delay=500] - The minimum duration in milliseconds.
 * @returns {Promise<T>} A promise that resolves with the result of `asyncFunc`.
 * * @example
 * const data = await minimumLoadingTime(() => fetchUserData(id), 1000);
 */

export async function minimumLoadingTime(asyncFunc, delay=500) {
  const [asyncFuncResult] = await Promise.all([
    asyncFunc(),
    // minimumLoadingTime
    new Promise((resolve) => setTimeout(() => resolve('minimum delay'), delay)),
  ])
  return asyncFuncResult
}
